/**
 * Predefined TOC structures for Step 2.
 * Simpler than full templates — they only define sections and pages, not modules.
 */
export const SUGGESTED_STRUCTURES = [
  {
    id: 'intro-modules-summary',
    nameKey: 'courseGuide.structure.introModulesSummary.name',
    descriptionKey: 'courseGuide.structure.introModulesSummary.description',
    icon: 'EditNote',
    sections: [
      { nameKey: 'courseGuide.structure.intro', pages: [{ nameKey: 'courseGuide.structure.welcome' }] },
      {
        nameKey: 'courseGuide.structure.module1',
        pages: [
          { nameKey: 'courseGuide.structure.lesson1' },
          { nameKey: 'courseGuide.structure.lesson2' },
        ],
      },
      {
        nameKey: 'courseGuide.structure.module2',
        pages: [
          { nameKey: 'courseGuide.structure.lesson3' },
          { nameKey: 'courseGuide.structure.lesson4' },
        ],
      },
      {
        nameKey: 'courseGuide.structure.module3',
        pages: [
          { nameKey: 'courseGuide.structure.lesson5' },
          { nameKey: 'courseGuide.structure.lesson6' },
        ],
      },
      { nameKey: 'courseGuide.structure.summary', pages: [{ nameKey: 'courseGuide.structure.wrapUp' }] },
    ],
  },
  {
    id: 'intro-modules-quiz-cert',
    nameKey: 'courseGuide.structure.introModulesQuizCert.name',
    descriptionKey: 'courseGuide.structure.introModulesQuizCert.description',
    icon: 'Certificate',
    sections: [
      { nameKey: 'courseGuide.structure.intro', pages: [{ nameKey: 'courseGuide.structure.welcome' }] },
      {
        nameKey: 'courseGuide.structure.module1',
        pages: [
          { nameKey: 'courseGuide.structure.lesson1' },
          { nameKey: 'courseGuide.structure.lesson2' },
        ],
      },
      {
        nameKey: 'courseGuide.structure.module2',
        pages: [
          { nameKey: 'courseGuide.structure.lesson3' },
          { nameKey: 'courseGuide.structure.lesson4' },
        ],
      },
    ],
    suggestQuiz: true,
    suggestDiploma: true,
  },
  {
    id: 'simple',
    nameKey: 'courseGuide.structure.simple.name',
    descriptionKey: 'courseGuide.structure.simple.description',
    icon: 'Edit',
    sections: [
      {
        nameKey: 'courseGuide.structure.mainContent',
        pages: [
          { nameKey: 'courseGuide.structure.page1' },
          { nameKey: 'courseGuide.structure.page2' },
          { nameKey: 'courseGuide.structure.page3' },
        ],
      },
    ],
  },
  {
    id: 'empty',
    nameKey: 'courseGuide.structure.empty.name',
    descriptionKey: 'courseGuide.structure.empty.description',
    icon: 'Add',
    sections: [
      {
        nameKey: 'courseGuide.structure.section1',
        pages: [{ nameKey: 'courseGuide.structure.page1' }],
      },
    ],
  },
];

/**
 * Convert a suggested structure into the guide's tocStructure format.
 * @param {Object} structure - A structure from SUGGESTED_STRUCTURES
 * @param {Function} t - i18next translation function
 * @returns {Array} tocStructure
 */
export const applySuggestedStructure = (structure, t) => {
  let counter = 1;
  return structure.sections.map((section) => ({
    id: `temp-section-${counter++}`,
    name: t(section.nameKey),
    pages: section.pages.map((page) => ({
      id: `temp-page-${counter++}`,
      name: t(page.nameKey),
    })),
  }));
};
